/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { reduxForm, submit } from 'redux-form';
import PropTypes from 'prop-types';
import { ContactModalView } from './contact-modal-view';
import { ADD_CONTACT_FORM_NAME } from '../../constants';
import ModalFooterButtons from '../../../../semantic-ui/components/modal-window/modal-footer-buttons';
import { ModalWindow } from '../../../../semantic-ui/components/modal-window';
import { createContactAction } from '../../actions';
import { validateContactForm } from '../../utils';
import { getIsContactInfoLoadingSelector } from '../../selectors';

const ContactModalWrapper = ({ onSetIsModalShow, onCreateContact, onFormSubmit, isContactInfoLoading }) => {
	const handleModalClose = () => {
		onSetIsModalShow(false);
	};

	const handleContactFormSubmit = async () => {
		await onFormSubmit(ADD_CONTACT_FORM_NAME);

		onCreateContact({ redirect: handleModalClose });
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleContactFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText="Создать контактное лицо"
			modalContent={<ContactModalView />}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'profile' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={[]}
					rightButtons={[
						{
							onClick: handleContactFormSubmit,
							text: 'Сохранить',
							color: 'primary',
							loading: isContactInfoLoading,
							disabled: isContactInfoLoading,
						},
						{
							onClick: handleModalClose,
							text: 'Отмена',
							color: 'secondary',
							disabled: isContactInfoLoading,
						},
					]}
				/>
			}
		/>
	);
};

const withForm = reduxForm({
	form: ADD_CONTACT_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validateContactForm,
})(ContactModalWrapper);

const mapStateToProps = createStructuredSelector({
	isContactInfoLoading: getIsContactInfoLoadingSelector(),
});

const mapDispatchToProps = {
	onFormSubmit: submit,
	onCreateContact: createContactAction,
};

const ContactModal = connect(mapStateToProps, mapDispatchToProps)(withForm);

ContactModalWrapper.propTypes = {
	onSetIsModalShow: PropTypes.func.isRequired,
	onCreateContact: PropTypes.func.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	isContactInfoLoading: PropTypes.bool.isRequired,
};

export { ContactModal };
